import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard.vue";
import IntermediateEntries from "@/pages/IntermediateEntries.vue";
import ApprovedEntries from "@/pages/ApprovedEntries.vue";
import EditEntry from "@/pages/EditEntry.vue";
import AddEntry from "@/pages/AddEntry.vue";
import EditStagingEntry from "@/pages/EditStagingEntry.vue"
import { authGuard } from "../auth/authGuard";
import ApprovedNegatori from "@/pages/ApprovedNegatori.vue"
import ApprovedPlatforms from "@/pages/ApprovedPlatforms.vue"
import EditCleanCin from "@/pages/EditCleanCin.vue";
import EditNegator from "@/pages/EditNegator.vue";
import EditPlatform from "@/pages/EditPlatform.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    beforeEnter: authGuard,
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        beforeEnter: authGuard
      },
      {
        path: "cleantable",
        name: "Odobreni unosi",
        component: ApprovedEntries,
        beforeEnter: authGuard
      },
      {
        path: "/editentry/:id",
        name: "editentry",
        component: EditCleanCin,
        beforeEnter: authGuard
      },
      {
        path: "addentry",
        name: "addentry",
        component: AddEntry,
        beforeEnter: authGuard
      },
      {
        path: "editstg/:id",
        name: "editstg",
        component: EditStagingEntry,
        beforeEnter: authGuard
      },
      {
        path: "intermediate",
        component: IntermediateEntries,
        beforeEnter: authGuard
      },
      {
        path: "negatori",
        component: ApprovedNegatori,
        beforeEnter: authGuard
      },
      {
        path: "platforme",
        component: ApprovedPlatforms,
        beforeEnter: authGuard
      },
      {
        path: "editnegator/:id",
        component: EditNegator,
        beforeEnter: authGuard
      },
      {
        path: "editplatform/:id",
        component: EditPlatform,
        beforeEnter: authGuard
      }
      
    ]
  },
  
];

export default routes;
